import Button from './Button.vue';
import ButtonWithOptions from './ButtonWithOptions.vue';

export default [
  Button,
  ButtonWithOptions,
];
